import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import TypedLink from '../TypedLink/TypedLink.js';

import './Banner.css';

class Banner extends React.Component {

  image = '';
  url = '';
  children = '';

  constructor(props) {

    super(props);

    this.type = props.type ? props.type : '';
    this.image = props.image ? props.image : '';
    this.url = props.url ? props.url : '';
    this.text = props.text ? props.text : '';
    this.children = props.children ? props.children : '';
  }

  render() {
    return (
      <div className="banner">
        {this.url 
          ? <TypedLink link={{type:this.type, url: this.url, title: ''}} ><img src={process.env.REACT_APP_API_SERVER_URL+'upload_files/banners/'+this.image} />{this.children}</TypedLink>
          : <><img src={process.env.REACT_APP_API_SERVER_URL+'upload_files/banners/'+this.image} />{this.children}</>
        }
      </div>
    );
  }
};

export default Banner;
